export { FolderOpenAlt as default } from './FolderOpenAlt';
